<template>
  <!--专题详情  -->
  <div class="topicDetail">
    <div class="detail_box">
      <el-card>
        <el-row>
            <el-button
              type="primary"
              @click="getList"
              :disabled="tabOpen && allOpen"
              >置顶新闻</el-button
            >
          </el-row>
        <el-row>
          <el-table
            :data="topNewsList"
            :header-cell-style="getRowClass"
            border
            ref="multipleTable"
            style="width: 100%; flex: auto; margin-top: 20px"
            tooltip-effect="light"
            v-if="topNewsShow"
          >
            <el-table-column
              prop="newsTitle"
              label="标题"
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              class-name="small-padding fixed-width"
              label="操作"
              width="200px"
            >
              <template slot-scope="{ row }">
                <el-button type="primary" @click="deleteNews(row.contentId)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          
        
        </el-row>
      </el-card>
      <el-card>
        <el-row>
          <el-button
            type="primary"
            @click="add"
            :disabled="tabOpen && allOpen"
            v-if="menuPerm('special:query')"
            >添加栏目</el-button
          >
        </el-row>
        <a-tabs
          type="editable-card"
          @edit="onEdit"
          hide-add
          style="margin-top: 20px"
          v-model="$store.state.keys"
          @tabClick="tabDian && clickEvent()"
        >
          <!-- tab类型切换新闻-->
          <a-tab-pane
            v-for="item in typeList"
            :key="item.id"
            :closable="tabDel"
            :disabled="tabOpen && allOpen"
          >
            <span slot="tab">
              <i
                class="el-icon-edit"
                @click="EditTypes(item.id)"
                style="font-size: 17px"
                v-if="tabEdit"
              ></i>
              <span @click="getNewDas(item.id)" style="marginleft: 10px">{{
                item.specialType
              }}</span>
            </span>
            <el-table
              :data="newList"
              :header-cell-style="getRowClass"
              border
              ref="multipleTable"
              style="width: 100%; flex: auto; margin-top: 20px"
              tooltip-effect="light"
            >
              <el-table-column
                prop="newsTitle"
                label="标题"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="createTimestamp"
                label="创建时间"
                align="center"
              ></el-table-column>

              <el-table-column
                align="center"
                class-name="small-padding fixed-width"
                label="操作"
                width="200px"
              >
                <template slot-scope="{ row }">
                  <el-button
                    type="primary"
                    @click="delNew(item.id, row.id)"
                    :disabled="tabOpen && allOpen"
                    v-if="menuPerm('special:query')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <el-button
                type="primary"
                @click="getRelaNew(item.id)"
                style="margintop: 20px"
                :disabled="tabOpen && allOpen"
                v-if="menuPerm('special:query')"
                >添加新闻</el-button
              >
            </el-row>
          </a-tab-pane>
        </a-tabs>
      </el-card>
      <!-- 获取指定专题的所有 -->
      <el-card>
        <el-row>
          <el-button
            type="primary"
            @click="getaddPub"
            :disabled="tabOpen && allOpen"
            v-if="menuPerm('special:query')"
            >添加 pub</el-button
          >
        </el-row>
        <el-table
          :data="pubList"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto; margin-top: 20px"
          tooltip-effect="light"
        >
          <el-table-column
            prop="imgUrl"
            label="图片url"
            width="200px"
            height="200px"
          >
            <template slot-scope="{ row }">
              <div class="topic_img">
                <img :src="row.imgUrl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="pubTitle"
            label="标题"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="sort"
            label="排序"
            align="center"
          ></el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="180px"
          >
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                @click="geteditPub(row)"
                :disabled="tabOpen && allOpen"
                v-if="menuPerm('special:query')"
                >修改</el-button
              >
              <el-button
                type="primary"
                @click="delPub(row.id)"
                :disabled="tabOpen && allOpen"
                v-if="menuPerm('special:query')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <!-- 置顶新闻添加 -->
    <a-modal
      title="置顶新闻添加"
      :visible="newsModel"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
      style="width:600px"
    >
      <el-row style="margin-top: 20px">
        <el-col :span="8">
          <el-input
            placeholder="请输入标题"
            v-model="title"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" @click="getList" style="margin: 0 0 0 10px"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="newsList"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto; margin-top: 20px"
        tooltip-effect="light"
      >
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          width="200px"
        >
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              @click="addNews(row.contentId)"
              :disabled="tabOpen && allOpen"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
       <el-row
          style="width: auto; marginright: 50px; margin-top: 20px"
          v-if="newsModel"
        >
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            class="pagesize"
          ></el-pagination>
        </el-row>
    </a-modal>
    <!-- 专题类型添加 -->
    <a-modal
      title="专题栏目添加"
      :visible="typeOpen"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="typeAdd"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="marginleft: -70px"
      >
        <el-row>
          <el-form-item label="类型名字" prop="typeName">
            <el-input
              placeholder="请输入内容"
              v-model="typeAdd.typeName"
              clearable
            />
          </el-form-item>
        </el-row>

        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitType"
            v-if="menuPerm('special:query')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>
    <!-- 专题类型修改 -->
    <a-modal
      title="专题类型修改"
      :visible="typeEditOpen"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="typeEdit"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="marginleft: -70px"
      >
        <el-row>
          <el-form-item label="类型名字" prop="name">
            <el-input
              placeholder="请输入内容"
              v-model="typeEdit.name"
              clearable
            />
          </el-form-item>
        </el-row>

        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="hanleEditType"
            v-if="menuPerm('special:query')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>
    <!-- 添加关联新闻 -->
    <a-modal
      title="关联新闻"
      :visible="relatedNew"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="typeEdit"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="marginleft: -70px"
      >
        <el-row>
          <el-form-item label="类型名字" prop="name">
            <el-input
              placeholder="请输入内容"
              v-model="typeEdit.name"
              clearable
            />
          </el-form-item>
        </el-row>

        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="hanleEditType"
            v-if="menuPerm('special:query')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>

    <!-- 添加pub -->
    <a-modal
      title="添加pub"
      :visible="addPubs"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="addpub"
        :rules="addRules"
        label-position="right"
        ref="addForms"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" prop="pubTitle">
              <el-input
                placeholder="请输入内容"
                v-model="addpub.pubTitle"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="图片" prop="imgUrl" ref="imgUrl">
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="AddPubUpt"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                v-model="addpub.imgUrl"
              >
                <img v-if="addpub.imgUrl" :src="addpub.imgUrl" class="avatar" />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 15px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('addForms')"
            v-if="menuPerm('special:query')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>

    <!-- 修改pub -->
    <a-modal
      title="修改pub"
      :visible="editPubs"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="editpub"
        :rules="editRules"
        label-position="right"
        ref="ruleForm"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="标题" prop="pubTitle">
              <el-input
                placeholder="请输入内容"
                v-model="editpub.pubTitle"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="排序" prop="sort">
              <el-date-picker
                v-model="editpub.sort"
                type="datetime"
                placeholder="选择日期时间"
                format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="专题封面图" prop="imgUrl">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="EditPubUpt"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
            >
              <img v-if="editpub.imgUrl" :src="editpub.imgUrl" class="avatar" />

              <i
                :class="
                  editLoad
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 260px; margin-top: 20px"
            type="primary"
            @click="submitEdit('ruleForm')"
            v-if="menuPerm('special:query')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>

    <!-- 删除弹框 -->
    <a-modal
      title
      :visible="delOpen"
      @ok="delOk"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.addpub.imgUrl == "") {
        callback(new Error("专题封面图不能为空"));
      } else {
        callback();
      }
    };
    return {
      newsModel: false,
      editPubImg: [], //上传图片
      editLoad: false,
      //校验
      editRules: {
        pubTitle: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
      },
      editpub: "",
      editPubs: false,
      loadUpt: false, //加载
      //添加参数
      addpub: {
        pubTitle: "", //标题
        imgUrl: "", //图片 url
      },
      //校验
      addRules: {
        pubTitle: [
          { required: true, message: "标题不能为空", trigger: "blur" },
        ],
        imgUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
      },
      addPubImg: [], //上传图片
      // ------------------------------------------------------

      addPubs: false,
      AddId: "",
      Addvisible: false,
      visible: false,
      editData: "",
      allOpen: true, //没有限制
      tabDian: false, //tab点击事件
      tabEdit: true, //tab修改禁用
      tabDel: true, //tab删除禁用
      tabOpen: false, //tab禁用框
      delId: "", //专题pubId
      delOpen: false, //专题删除弹框
      typeOpen: false, //专题类型的添加弹框
      typeEditOpen: false, //专题类型的修改弹框
      relatedNew: false, //关联新闻弹框
      editId: "", //修改类型id
      typeList: [], //专题的所有类型列表
      newList: [], //关联新闻列表
      //类型添加参数：
      typeAdd: {
        typeName: "", //类型名字
      },
      //类型修改参数：
      typeEdit: {
        name: "",
      },
      pubList: [], //获取指定专题的所有 pub
      topicId: "", //专题id
      keys: "", //tab-key
      backOpen: true,
      newsList: [],
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示，
      current: 0,
      topNewsList: [],
      topNewsShow: false,
      title: "",
    };
  },
  components: {},
  computed: {},
  props: ["Detaildata"],
  methods: {
    // 添加新闻
    addNews(id) {
      this.getAxios("/special/add/topNews", {
        newsId: id,
        specialId: this.Detaildata.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.topNewsList = [];
          this.getTopNews();
          this.topNewsShow = true;
          this.newsModel=false;
        }
      });
    },
    // 删除新闻
    deleteNews() {
      this.getAxios("/special/delete/topNews", {
        specialId: this.Detaildata.id,
      }).then((res) => {
        this.$message.success(res.message);
        this.getTopNews();
        this.topNewsShow = false;
      });
    },
    // 获取置顶新闻
    getTopNews() {
      this.getAxios("/special/topNews", {
        specialId: this.Detaildata.id,
      }).then((res) => {
        if (res.entity == null) {
          this.topNewsShow = false;
        } else {
          this.topNewsShow = true;
        }
        this.topNewsList.push(res.entity);
        console.log(this.topNewsList, "15151515");
      });
    },
    // 获取添加新闻列表
    getList() {
      this.newsModel = true;
      this.postAxios("/rotation/listAllContentByType", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        q: {
          contentType: 1,
          title: this.title,
        },
      }).then((res) => {
        this.newsList = res.content;
        this.totalCount = res.totalCount;
        console.log(this.newsList, "5555555");
      });
    },
    //转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise((resolve) => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          img.src = e.target.result;
        };

        img.onload = function () {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            (blob) => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    handleSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
      this.$refs.imgUrl.clearValidate(); //img
    },
    //图片上传：
    EditPubUpt(file, fileList) {
      this.editLoad = true;
      this.editPubImg = [];
      this.getBase64(file).then((resBase64) => {
        this.editPubImg.push(resBase64);
        if (this.editPubImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.editPubImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.editpub.imgUrl = res.content[0]; //接口url参数
              this.editPubImg = [];
              this.editLoad = false;
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //图片上传：
    AddPubUpt(file, fileList) {
      this.loadUpt = true; //加载
      this.addPubImg = [];
      this.getBase64(file).then((resBase64) => {
        this.addPubImg.push(resBase64);
        if (this.addPubImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.addPubImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.addpub.imgUrl = res.content[0]; //接口url参数
              this.addPubImg = [];
              this.$refs.imgUrl.clearValidate();
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      //   time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //修改：
    submitEdit(formName) {
      var sort = new Date(this.editpub.sort).getTime() / 1000;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/special/update/pub", {
            id: this.editpub.id,
            pubTitle: this.editpub.pubTitle, //标题
            imgUrl: this.editpub.imgUrl, //图片 url
            sort: sort, // 排序
            specialId: this.Detaildata.ids, //专题的 id
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("修改成功！");
              this.getPub();
              this.editPubs = false;
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
    //新增：
    submitAdd(formName) {
      // var sort = new Date(this.addpub.sort).getTime()/1000

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/special/add/pub", {
            pubTitle: this.addpub.pubTitle, //标题
            imgUrl: this.addpub.imgUrl, //图片 url
            // sort: sort, // 排序
            specialId: this.Detaildata.id, //专题的 id
          }).then((res) => {
            if (res.success == true) {
              // this.$router.go(-1);
              this.getPub();
              this.$message.success("添加成功！");
              this.addPubs = false;
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
    // ------------------------------------
    onClose() {
      this.visible = false;
      this.Addvisible = false;
      this.newsModel=false;
      this.getType();
    },

    // ...mapMutations(['getCreaDas']),
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },

    //专题的所有类型列表:
    getType() {
      var id = this.Detaildata.id;

      this.getAxios("/special/listType", {
        specialId: id,
      }).then((res) => {
        if (res.success == true) {
          this.typeList = res.content; //专题列表
          this.$store.commit("getCreaDas", this.typeList[0].id);
          this.creaNews(this.$store.state.creaDas);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //新增、删除回调：
    onEdit(targetKey, action) {
      this[action](targetKey);
    },
    clickEvent() {}, //禁止tab点击
    //弹框取消
    handleCancel() {
      this.typeOpen = false;
      this.typeEditOpen = false;
      this.delOpen = false;
      this.addPubs = false;
      this.editPubs = false;
      this.newsModel=false;
    },
    //类型添加：
    add() {
      this.typeOpen = true;
      this.typeAdd = {};
    },

    //类型添加保存：
    submitType() {
      var id = this.Detaildata.id;
      this.getAxios("/special/addType", {
        specialId: id,
        typeName: this.typeAdd.typeName,
      }).then((res) => {
        if (res.success == true) {
          this.getType();
          this.$message.success("专题类型添加成功！");
          this.typeOpen = false;
        } else if (res.success == true) {
          this.$message.error("专题类型添加失败！");
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //初始化已关联新闻列表：
    creaNews() {
      var ids = this.$store.state.keys;
      var id = this.Detaildata.id;
      this.getAxios("/special/listNews", {
        specialId: id,
        typeId: ids,
      }).then((res) => {
        if (res.success == true) {
          this.newList = res.content;
          // 时间戳转时间
          this.newList.map((i, index) => {
            if (i.reviewTimestamp != null) {
              var timeTrans = new Date(parseInt(i.reviewTimestamp) * 1000);
              let reviewTimestamp = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(
                this.newList[index],
                `createTimestamp`,
                reviewTimestamp
              );
            } else {
              this.$set(this.newList[index], `createTimestamp`, "");
            }
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //点击类型出现新闻列表：
    getNewDas(ids) {
      this.keys = ids;

      this.$store.commit("submitKey", ids);

      this.creaNews(this.$store.state.keys);
    },
    //修改类型：
    EditTypes(id) {
      this.editId = id;
      this.typeEditOpen = true;
      //修改弹框的名字的显示
      this.typeList.filter((item, index) => {
        item.id == id ? (this.typeEdit.name = item.specialType) : "";
      });
    },

    //类型修改：
    hanleEditType() {
      this.getAxios("/special/type/updateTypeName", {
        specialTypeId: this.editId,
        name: this.typeEdit.name,
      }).then((res) => {
        if (res.success == true) {
          this.getType();
          this.$message.success("专题类型修改成功！");
          this.typeEditOpen = false;
        } else if (res.success == true) {
          this.$message.error("专题类型修改失败！");
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },

    //删除类型：
    remove(targetKey) {
      this.getAxios("/special/delete/type", {
        typeId: targetKey,
      }).then((res) => {
        if (res.success == true) {
          this.getType();
          this.$message.success("专题类型删除成功！");
        } else if (res.success == true) {
          this.$message.error("专题类型删除失败！");
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //获取关联新闻--无数据：
    getRelaNew(ids) {
      this.$router.push({ path: "/relaNew", query: { id: ids } });
    },

    //类型删除新闻：
    delNew(ids, idNew) {
      this.getAxios("/special/type/removeNews", {
        specialTypeId: ids, //类型 id
        newsInfoId: idNew, //新闻 id
      }).then((res) => {
        if (res.success == true) {
          this.creaNews(ids);
          this.$message.success("关联新闻删除成功！");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 获取指定专题的所有 pub
    getPub() {
      var id = this.Detaildata.id;
      this.getAxios("/special/list/pub", {
        specialId: id,
      }).then((res) => {
        if (res.success == true) {
          this.pubList = res.content;
          // 时间戳转时间
          this.pubList.map((i, index) => {
            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let revieTime = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });

              this.$set(this.pubList[index], `sort`, revieTime);
            } else {
              this.$set(this.pubList[index], `sort`, "");
            }
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //添加 pub：
    getaddPub() {
      // this.AddId = this.Detaildata.id
      // this.Addvisible = true

      this.addPubs = true;
      this.$refs["addForms"].clearValidate();
      this.$refs["addForms"].resetFields();
      this.addpub = "";
      this.loadUpt = "";

      // this.$router.push({ path: "/addPub", query: { id: id } });
    },
    //修改 pub：
    geteditPub(obj) {
      this.editpub = obj;
      this.editPubs = true;

      // this.editData = obj;
      // this.visible = true;
    },
    // "/special/delete/pub?"+"pubId"=ids
    //删除 pub：
    delPub(ids) {
      this.delOpen = true;
      this.delId = ids;
    },
    //删除pub
    delOk() {
      this.postAxios(`/special/delete/pub?pubId=${this.delId}`, {}).then(
        (res) => {
          if (res.success == true) {
            this.$message.success("删除成功！");
            this.getPub();
            this.delOpen = false;
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        }
      );
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  created() {
    if (
      this.Detaildata.examineStatus == 2 ||
      this.Detaildata.examineStatus == 4
    ) {
      // 没限制
      this.tabOpen = false; //no
      this.tabDel = true; //no
      this.tabEdit = true; //no
    } else if (
      (this.Detaildata.examineStatus == 1 ||
        this.Detaildata.examineStatus == 3) &&
      this.allOpen
    ) {
      this.tabOpen = true; //tab禁用
      this.tabDel = false; //删除禁用
      this.tabEdit = false; //修改消失
    }
  },
  mounted() {
    this.getType(); //专题的所有类型列表
    this.getPub(); // 获取指定专题的所有 pub
    this.getTopNews();
    if (this.menuPerm("special:edit_super") == true) {
      this.allOpen = false;
      this.tabEdit = true;
      this.tabDel = true;
    }
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.getType();
      this.getPub();
      this.getTopNews();
    },
  },
};
</script>
<style scoped lang="less">
.topicDetail {
  width: 100%;
  height: 100%;
  .detail_box {
    width: 95%;
    height: 100%;
    margin: 20px auto;

    /deep/ .ant-tabs-extra-content .ant-tabs-new-tab svg {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      font-size: 20px;
      background: #ccc;
    }

    .el-card {
      margin-top: 15px;
      .topic_img {
        width: 200px;
        height: 200px;
        margin-left: -10px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
      margin-top: 10px;
      margin-left: 10px;
    }
  }
  /deep/ .ant-modal-content .el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    width: 100px;
    margin-top: 10px;
    margin-left: 10px;
  }

  /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #40a9ff;
    background: #fff;
    border-color: #fff;
    /* border-bottom: 1px solid #fff; */
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab:hover {
    color: #40a9ff;
  }
}

/deep/ .el-upload {
  width: 200px;
  height: auto;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
  img {
    width: 100%;
    height: auto;
  }
}
/deep/ .el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 100px;
}
/deep/ .pagesize .el-pagination__rightwrapper{
  display: none;
}
</style>